module.exports = __webpack_public_path__ + "img/Logo-20.7a135066.svg";